const EasyAccessPT = {
  EasyAccess: {
    NOT_INVITED: 'Você recebeu um convite? Verifique seu email e acesse através do link recebido.',
    'LOGIN-TEXT': 'Conecte sua conta do Facebook com esse novo projeto da ',
    'WELCOME-TEXT': 'Bem-vindo(a) ao Gerentes Digitais.',
    'PAGE-MESSAGE': 'Você precisa de uma página para seu negócio! Caso não possua uma, ',
    'PAGE-MESSAGE-2': ' para criar!',
    'CLICK-HERE': ' clique aqui',
    CONFIRM: 'CONFIRMAR',
    CANCEL: 'CANCELAR',
    ATENTION: 'ATENÇÃO',
    'REDIRECT-BUSINESS':
            'Atenção! Você será redirecionado para o Facebook. Assim que completar este passo, retorne para esta janela ou aguarde as próximas instruções por email.',
    'PERMISSION-ERROR':
            'Você desmarcou uma permissão indispensável para participar do projeto. Por favor, faça o login novamente e selecione todas as opções!',
  },
};

const EasyAccessEN = {
  EasyAccess: {
    NOT_INVITED: 'Did you get an invitation? Check your email and access through the link received.',
    'LOGIN-TEXT': 'Connect your Facebook account with this new project from ',
    'WELCOME-TEXT': 'Welcome to Gerentes Digitais.',
    'PAGE-MESSAGE': "You need a page for your business! If you don't have one,",
    'CLICK-HERE': ' click here',
    'PAGE-MESSAGE-2': ' to create it!',
    CONFIRM: 'CONFIRM',
    CANCEL: 'CANCEL',
    ATENTION: 'ATENTION',
    'REDIRECT-BUSINESS':
            'You will be directed to accept the invitation from the Facebook Business Manager. Once you complete this step, the next instructions will come via email. See you there!',
    'PERMISSION-ERROR':
            'You have unchecked an indispensable permission to participate in the project. Please log in again and select all options!',
  },
};

export { EasyAccessPT, EasyAccessEN };
